import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Input } from "antd";

const SurveyKpiLabel = styled(Input.TextArea)`
  width: 97%;
  padding: 5px;
  margin: 0px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  resize: none;
`;
class StatementLabel extends Component {
  constructor(props) {
    super(props);
  }

  /**
   * add &nbsp before ? to prevent unwanted line break
   */
  format(v) {
    return v.replace(" ?", `\u00A0?`);
  }
  render() {
    const { label, updateStatementLabel } = this.props;

    return (
      <SurveyKpiLabel
        autosize={{ minRows: 2, maxRows: 2 }}
        placeholder="Votre question personnalisée"
        value={this.format(label)}
        onChange={e => {
          const { value } = e.target;
          updateStatementLabel(value);
        }}
      />
    );
  }
}

StatementLabel.propTypes = {
  label: PropTypes.string.isRequired,
  locationType: PropTypes.object.isRequired,
  statement: PropTypes.object.isRequired,
  updateStatementLabel: PropTypes.func.isRequired
};

export default StatementLabel;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpiTabElements/StatementLabel.js